export const TYPES = { CHILDS: 'childs', PARENTS: 'parents' }

export const LOCALE_PREFIX = 'components.Banners.components.OwnershipBanner'
